import PageModule from "@eisinc/Overrides/Pages/BrandDetailsPage";

export * from "@eisinc/Overrides/Pages/BrandDetailsPage";

export default PageModule;
